import { isCorporateClient } from '@/composables/useEdverumClient.js';

export const VERTICAL_CORPORATE = 'corporate';
export const VERTICAL_REGULAR = 'regular';

/**
 * Map the deploy-time Edverum client variant to the Amplitude "vertical"
 * dimension used for Guided Tour targeting:
 *   - corporate client            -> "corporate"
 *   - everything else (stanbridge / default) -> "regular"
 *
 * Backed by the canonical {@link isCorporateClient} helper, so the client
 * variant stays the single source of truth; this only renames the values for
 * the audience-facing Amplitude property.
 *
 * @returns {'corporate'|'regular'}
 */
export const getAmplitudeVertical = () => (isCorporateClient() ? VERTICAL_CORPORATE : VERTICAL_REGULAR);
